export default "__VITE_ASSET__DuSwsPRC__"